import React, { useEffect, useState } from "react";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import ProfileCompletionEducationDiv from "./ProfileCompletionEducationDiv";
import ProfileCompletionEducationModal from "./ProfileCompletionEducationModal";
import { isEmpty } from "lodash";

 
function ProfileCompletionCandidateEducation({data,getUpdatedData,asterikSign,errorSec, error}) {
 
const [educationData,setEducationData]=useState([])
const [editData,setEditData]=useState({})
const [educationModal,setEducationModal]=useState(false)


useEffect(()=>{
  setEducationData(data)
  },[data])



const onEditEducationData=(data)=>{
setEditData(data)
setEducationModal(true)
}

const onAddEducationData=()=>{
    setEditData({})
    setEducationModal(true)
}

    return (
        <>
          <div style={{marginTop:10,paddingLeft:20,marginBottom:50}} >
      
    <div   style={{
    flex: 1,
    flexDirection: 'row',
    display: 'flex',
    width: '500px',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 5,
    ...(isEmpty(error) || !isEmpty(data)
      ? {}
      : {
          borderRadius: 10,
          border: '2px solid red',
          height: 50,
          padding: 20,
          right: 40,
        }),
  }}
>
    <div style={{flex:1,flexDirection:'row',display:'flex',marginTop:10}}>
<h3 style={{ fontWeight:'600',
fontSize:'16px',color: '#373a40'}}>Education</h3>
{asterikSign()}
</div>
    <div onClick={onAddEducationData} className="add_icon" style={{marginTop:0}}>
    <AddCircleOutlineIcon fontSize="large" style={{marginTop:'3px',marginLeft:'45px'}} />
    </div>       
    
       </div>
       {!isEmpty(error) && isEmpty(data)  && errorSec(error)}

    
    <div className="r9-education__c1-education-div">
    {
              educationData && 
              educationData?.map((degree, index) => {
                  return <ProfileCompletionEducationDiv key={index} degree={degree}  onEdit={onEditEducationData}/>;
                })
     
            }
    </div> 
    
          </div>
          {educationModal && (<ProfileCompletionEducationModal editData={editData} dataList={educationData}  isVisible={educationModal} onClose={()=>{
           getUpdatedData()
           setEducationModal(false)
          }
          }/>)}
    
        </>
      );
}

export default ProfileCompletionCandidateEducation;
